import { Button, Popconfirm, Typography } from 'antd';
import { ChevronDown, ChevronUp, Pencil, Trash2 } from 'lucide-react';
import type { DropPoint } from '../../../jobs.api';

interface DropPointRowProps {
  dropPoint: DropPoint;
  position: number;
  isFirst: boolean;
  isLast: boolean;
  saving: boolean;
  onEdit: () => void;
  onRemove: () => void;
  onMoveUp: () => void;
  onMoveDown: () => void;
}

/** One stop in `DropPointList` — its own file so the list stays under the line limit. */
export function DropPointRow({ dropPoint, position, isFirst, isLast, saving, onEdit, onRemove, onMoveUp, onMoveDown }: DropPointRowProps) {
  return (
    <li className="flex items-center justify-between gap-3 rounded-lg border border-line bg-surface px-4 py-3">
      <div className="flex items-center gap-3">
        <span className="text-sm font-semibold text-muted">{position}</span>
        <div>
          <Typography.Text code>{dropPoint.zoneCode}</Typography.Text>
          <p className="text-sm text-muted">
            {dropPoint.contactName} · {dropPoint.contactPhone}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-1">
        <Button
          type="text"
          size="small"
          disabled={isFirst || saving}
          icon={<ChevronUp className="size-3.5" />}
          onClick={onMoveUp}
          aria-label={`Move stop ${position} up`}
        />
        <Button
          type="text"
          size="small"
          disabled={isLast || saving}
          icon={<ChevronDown className="size-3.5" />}
          onClick={onMoveDown}
          aria-label={`Move stop ${position} down`}
        />
        <Button type="text" size="small" icon={<Pencil className="size-3.5" />} onClick={onEdit} aria-label={`Edit stop ${position}`} />
        <Popconfirm title={`Remove stop ${position}?`} onConfirm={onRemove}>
          <Button type="text" size="small" danger icon={<Trash2 className="size-3.5" />} aria-label={`Remove stop ${position}`} />
        </Popconfirm>
      </div>
    </li>
  );
}
